import React from "react";
import "./style.css"
import MainHeading from "../../GlobalComponents/Utils/mainHeading";
import ShortDescription from "../../GlobalComponents/Utils/shortDescription";
import logo from "../../Assets/partners/aljazeera.png"
import alarby from "../../Assets/logos/alarby.png";
import orient from "../../Assets/logos/orient.png";
import skynews from "../../Assets/logos/skynews.png";
import mbc from "../../Assets/logos/mbc.png";

import orientLogo from "../../Assets/logos/OrientLogo.svg";
import lLogo from "../../Assets/logos/LLogo.svg";
import metaLogo from "../../Assets/logos/MetaLogo.svg";
import mbcLogo from "../../Assets/logos/MBCLogo.svg";
import skyNewsLogo from "../../Assets/logos/SkyNewsLogo.svg";
import alOudLogo from "../../Assets/logos/AlOudLogo.svg";
import alArabyLogo from "../../Assets/logos/AlarabyLogo.svg";
import { useTranslation } from 'react-i18next';

export default function OurPartners() {
    const { t ,i18n} = useTranslation();
    const images = [
        logo,
        orientLogo,
        lLogo,
        metaLogo,
        mbcLogo,
        skyNewsLogo,
        alOudLogo,
        alArabyLogo
      
      ];
    return (
        <div className="our_partners">
            <MainHeading align={'center'} width={'95%'} gap={'10px'} flexDirection={'row'} content1={t("partners.title").split(" ")[0] + " "}
  content2={t("partners.title").split(" ")[1]} />
            <ShortDescription width={"90%"} content={t("partners.description")} />
            <div className="our_partners_logos">
                {images.map((image, index) => (
                    <img key={index} src={image} alt={`ind ${index + 1}`} />
                ))}
            </div>
        </div>
    )
}